import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Renderer2,
  SimpleChange,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { WithdrawOpportunityPopupComponent } from 'src/app/modules/users/withdraw-opportunity-popup/withdraw-opportunity-popup.component';

@Component({
  selector: 'app-sub-header',
  templateUrl: './sub-header.component.html',
  styleUrls: ['./sub-header.component.scss'],
})
export class SubHeaderComponent implements OnInit, OnChanges, AfterViewInit {
  tlxleadfor: number;
  oppID: string;
  // color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';
  value = 50;
  constructor(
    public auth: AuthenticationService,
    public dialog: MatDialog,
    private renderer: Renderer2
  ) {}

  @Input('header') header: string;
  @Input('currentStage') currentStage = 0;
  @Input('totalStage') totalStage = 10;

  @ViewChild('circleBar', { static: false }) circleBar: ElementRef;

  // updatecircleSubscription: Subscription;

  showStage;
  // element: HTMLDivElement;
  isSticky = false;
  // progressBar = [];
  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    this.isSticky = window.pageYOffset >= 80;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.header = changes.header?.currentValue;

    if (
      changes.currentStage?.currentValue != changes.currentStage?.currentValue
    ) {
      this.currentStage = changes.currentStage.currentValue;
    }
    if (changes.totalStage?.currentValue != changes.totalStage?.previousValue) {
      this.totalStage = changes.totalStage.currentValue;
    }


    this.setcircleProgressBar();
  }
  ngOnInit(): void {
    this.showStage = this.currentStage;

  }
  ngAfterViewInit(): void {
    this.setcircleProgressBar();
  }
  disableOpportunity() {
    this.checkCurrentUrl();
    const oppID = this.oppID;
    const leadFor = this.tlxleadfor;

    if (oppID && leadFor) {
      const dialogRef = this.dialog.open(WithdrawOpportunityPopupComponent, {
        width: '720px',
        position: { right: '0', bottom: '0' },
        data: { type: 'add', data: oppID, leadFor },
      });
    } else {
      this.auth.showSnackBarMsg('No Related Application Found!');
    }
  }
  checkCurrentUrl() {
    // const currentUrl = this.router.url.split('?')[0];
    const currentUrl = this.auth.getCurrentUrl();
    if (
      currentUrl.includes('/user') ||
      currentUrl.includes('financial-goal') ||
      currentUrl.includes('refinance-consolidation')
    ) {
      this.tlxleadfor = 2;
      this.oppID = this.auth.getOPPByLeadFor(2);
    } else if (currentUrl.includes('/superannuation')) {
      this.tlxleadfor = 1;
      this.oppID = this.auth.getOPPByLeadFor(1);
    } else if (currentUrl.includes('/managed-account')) {
      this.tlxleadfor = 9;
      this.oppID = this.auth.getOPPByLeadFor(9);
    } else if (currentUrl.includes('/general-insurance')) {
      this.tlxleadfor = 4;
      this.oppID = this.auth.getOPPByLeadFor(4);
    } else if (currentUrl.includes('/estate-planning')) {
      this.tlxleadfor = 6;
      this.oppID = this.auth.getOPPByLeadFor(6);
    } else if (currentUrl.includes('/financial-planning')) {
      this.tlxleadfor = 7;
      this.oppID = this.auth.getOPPByLeadFor(7);
    } else if (currentUrl.includes('/health-insurance')) {
      this.tlxleadfor = 5;
      this.oppID = this.auth.getOPPByLeadFor(5);
    } else if (currentUrl.includes('/life-insurance')) {
      this.tlxleadfor = 3;
      this.oppID = this.auth.getOPPByLeadFor(3);
    }
  }
  setcircleProgressBar() {
    if (this.circleBar?.nativeElement && this.currentStage && this.totalStage) {
      let a = this.currentStage;
      if (a > 0) {
        a -= 1;
      }
      const b = this.totalStage;
      const c = Number(a / b).toFixed(2);
      const currentPercentage = +c * 100;
      this.renderer.setStyle(
        this.circleBar.nativeElement,
        'background',
        `radial-gradient(closest-side, white 80%, transparent 0 99.9%, white 0),conic-gradient(var(--fg) calc(var(--pgPercentage) * ${currentPercentage}%), var(--bg) 0)`
      );
    }
  }
}
